<h4 class="mb-27 mt-27">{{ 'revenue.arb-creation.arb-creation-activity' | translate }}</h4>
<div class="params-container mb-27 mct-flex mct-col mct-gap-27"  >
  <div>
    <span class="section-header">{{ 'revenue.arb-creation.search-arb-creation-activity' | translate }}</span>
  </div>
  <div class="mct-flex mct-row mct-gap-27"   [wl-busy-overlay]="busy" [busyCenter]="true">
    <div class="mct-flex mct-col" >
      <label>
        {{ 'revenue.credit-card-activity.start-date' | translate | ucfirst }}
      </label>
      <wl-date-selector #starDate appendTo="body" [(ngModel)]="searchParams.StartDate"></wl-date-selector>
    </div>
    <div class="mct-flex mct-col" >
      <label>
        {{ 'revenue.credit-card-activity.end-date' | translate | ucfirst }}
      </label>
      <wl-date-selector #endDate appendTo="body" [(ngModel)]="searchParams.EndDate"></wl-date-selector>
    </div>
    <div class="mct-flex mct-col" >
      <label>
        {{ 'revenue.credit-card-activity.credit-card-gateway' | translate | ucfirst }}
      </label>
      <p-select
        #ccGateWayId
        placeholder="{{ 'revenue.credit-card-activity.select-a-gateway' | translate | ucfirst }}"
        [options]="creditCardGateways"
        [(ngModel)]="searchParams.CcGatewayId"
        appendTo="body"
        [style]="{ 'min-width': '300px' }"
      ></p-select>
    </div>
  </div>
  <div class="mt-33 mct-flex mct-row mct-justify-end mct-items-center"  >
    <button pButton type="button" class="atlas-btn atlas-btn-primary" (click)="search()">
      {{ 'common.run-this-search' | translate | uppercase }}
    </button>
  </div>
</div>
<div class="divider-bar mb-21 mct-flex mct-row mct-justify-between mct-items-center"  >
  <div class="mct-flex mct-row mct-justify-end mct-items-center"  >
    <span *ngIf="!searchResult?.length; else resultsReturned" class="no-results">
      {{ 'common.no-search-results' | translate | ucfirst }}
    </span>
    <ng-template #resultsReturned>
      <span>{{ 'common.the-search-returned' | translate | ucfirst }}</span>
      &nbsp;
      <span class="f-wb">{{ searchResult.length }}</span>
      &nbsp;
      <span class="f-wb">{{ 'revenue.arb-creation.instances' | translate }}</span>
    </ng-template>
    <button pButton type="button"  class="mct-flex ml-10 atlas-btn atlas-btn-secondary mct-justify-center mct-items-center" type="button" (click)="clear()">
      <i class="large-icon pi pi-times"></i>
      <span>{{ 'common.clear-search' | translate | uppercase }}</span>
    </button>
  </div>
</div>
<div class="atlas-table" [hidden]="searchResult.length == 0">
  <p-table [showGridlines]="true" [value]="searchResult" [paginator]="true" [rows]="pageSize" [(first)]="first" [totalRecords]="searchResult.length">
    <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
      <SortAltIcon *ngIf="sortOrder === 0">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
      </SortAltIcon>
      <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
      </SortAmountUpAltIcon>
      <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
      </SortAmountDownIcon>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="BillingId">
          {{ 'revenue.arb-creation.billing-id' | translate | ucfirst }}
          <p-sortIcon field="BillingId"></p-sortIcon>
        </th>
        <th pSortableColumn="ArbId">
          {{ 'revenue.arb-creation.arb-id' | translate }}
          <p-sortIcon field="ArbId"></p-sortIcon>
        </th>
        <th pSortableColumn="AmountPerCycle">
          {{ 'revenue.arb-creation.amount' | translate | ucfirst }}
          <p-sortIcon field="AmountPerCycle"></p-sortIcon>
        </th>
        <th pSortableColumn="ReportName" style="width: 396px">
          {{ 'revenue.arb-creation.profile' | translate | ucfirst }}
          <p-sortIcon field="ReportName"></p-sortIcon>
        </th>
        <th pSortableColumn="DateCreated" style="width: 139px">
          {{ 'revenue.arb-creation.date' | translate | ucfirst }}
          <p-sortIcon field="DateCreated"></p-sortIcon>
        </th>
        <th pSortableColumn="Result" style="width: 220px">
          {{ 'revenue.arb-creation.result' | translate | ucfirst }}
          <p-sortIcon field="Result"></p-sortIcon>
        </th>
        <th pSortableColumn="Error">
          {{ 'revenue.arb-creation.error' | translate | titlecase }}
          <p-sortIcon field="Error"></p-sortIcon>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-arbCreationActivityItem>
      <tr>
        <td class="t-al">{{ arbCreationActivityItem.BillingId }}</td>
        <td class="t-al">{{ arbCreationActivityItem.ArbId }}</td>
        <td class="t-ar">{{ arbCreationActivityItem.AmountPerCycle | currency }}</td>
        <td>
          <wl-profile-type-icon
            class="ml-10px"
            [isMember]="arbCreationActivityItem.Member"
            [isOrg]="arbCreationActivityItem.OrgInd"
            [profileId]="arbCreationActivityItem.ProfileId"
          ></wl-profile-type-icon>
          {{ arbCreationActivityItem.ReportName }}
        </td>
        <td>{{ arbCreationActivityItem.DateCreated | date : 'MM/dd/yyyy' }}</td>
        <td>{{ arbCreationActivityItem.Result }}</td>
        <td>{{ arbCreationActivityItem.Error }}</td>
      </tr>
    </ng-template>
  </p-table>
<p-progressSpinner *ngIf="busy"></p-progressSpinner>
  <wl-page-size-dropdown [(pageSize)]="searchParams.PageSize" [pageSizes]="[20, 100, 0]"></wl-page-size-dropdown>
</div>

<wl-credit-card-activity-details-dialog #detailsDialog></wl-credit-card-activity-details-dialog>
